import React from 'react';
import { FadeIn } from './ui';
import { CheckCircle2, XCircle } from 'lucide-react';
const isFor = ["Mujeres de 40 a 55 años que sienten su metabolismo 'bloqueado'.", 'Madres o profesionales que sufren de fatiga crónica y falta de enfoque.', 'Mujeres que han probado todas las dietas y ven que su abdomen sigue igual.', 'Personas que buscan una solución basada en ciencia hormonal, no en pasar hambre.'];
const isNotFor = ["Personas que buscan una 'pastilla mágica' sin cambiar hábitos básicos.", 'Quienes prefieren seguir contando calorías en lugar de entender sus hormonas.', 'Atletas de alto rendimiento que no sufren de estrés metabólico.'];
export function WhoIsForSection() {
  return <section className="bg-white py-20 px-6 md:py-28" data-id="element-178">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-179">
        {/* Is For */}
        <FadeIn data-id="element-180">
          <div className="bg-sage/20 p-8 md:p-12 rounded-3xl border border-sage/50 h-full" data-id="element-181">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-navy mb-8" data-id="element-182">
              Es Para Ti Si...
            </h3>
            <ul className="space-y-6" data-id="element-183">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-184">
                  <CheckCircle2 className="w-7 h-7 text-navy flex-shrink-0 mt-0.5" data-id="element-185" />
                  <span className="text-lg text-gray-800 leading-relaxed" data-id="element-186">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        {/* Is Not For */}
        <FadeIn delay={0.2} data-id="element-187">
          <div className="bg-gray-50 p-8 md:p-12 rounded-3xl border border-gray-200 h-full" data-id="element-188">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-gray-500 mb-8" data-id="element-189">
              No Es Para Ti Si...
            </h3>
            <ul className="space-y-6" data-id="element-190">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-191">
                  <XCircle className="w-7 h-7 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-192" />
                  <span className="text-lg text-gray-600 leading-relaxed" data-id="element-193">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}